import {
  createFeatureSelector,
  createSelector,
  Action,
  combineReducers,
} from '@ngrx/store';

import * as fromDelivery from './delivery-statistics.reducer';
import * as fromJumpstory from './jumpstory-statistics.reducer';

export interface StatisticsState {
  delivery: fromDelivery.State;
  jumpstory: fromJumpstory.State;
}

export function reducers(state: StatisticsState | undefined, action: Action) {
  return combineReducers({
    delivery: fromDelivery.reducer,
    jumpstory: fromJumpstory.reducer,
  })(state, action);
}

const { selectAll } = fromJumpstory.adapter.getSelectors();

export const getStatisticsModuleState = createFeatureSelector<StatisticsState>(
  'Statistics',
);

export const getDeliveryStatistics = createSelector(
  getStatisticsModuleState,
  (state) => state.delivery,
);

export const getJumpstoryStatistics = createSelector(
  getStatisticsModuleState,
  (state) => state.jumpstory,
);

export const getAccounts = createSelector(
  getDeliveryStatistics,
  (state) => state.accounts,
);

export const getStatistics = createSelector(
  getDeliveryStatistics,
  (state) => state.statistics,
);

export const getStatisticsOverTime = createSelector(
  getDeliveryStatistics,
  (state) => state.statisticsOverTime,
);

export const getDomainStatistics = createSelector(
  getDeliveryStatistics,
  (state) => state.domains,
);

export const getSendingsStatistics = createSelector(
  getDeliveryStatistics,
  (state) => state.sendings,
);

export const getCountryCodesStatistics = createSelector(
  getDeliveryStatistics,
  (state) => state.countryCodes,
);

export const getLoading = createSelector(
  getDeliveryStatistics,
  (state) => state.loading,
);

export const getCurrentParameters = createSelector(
  getDeliveryStatistics,
  (state) => ({ accountId: state.accountId, dateRange: state.dateRange }),
);

export const getAllJumpstoryStatistics = createSelector(
  getJumpstoryStatistics,
  selectAll,
);
